export default __webpack_public_path__ + "static/article-budgeting-for-you-and-your-bump-21019f433e63212b14b38fb3053e2388.jpg";